<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="6">
                <h4>Gestión de roles</h4>
            </vs-col>
            <vs-col sm="12" lg="6">
                <vs-button
                    success
                    class="ml-auto"
                    @click="activeCrear =! activeCrear"
                >
                    <i class="fas fa-plus mr-2"></i> Crear rol
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <template v-if="instituciones.length" autocomplete="off">
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Rol <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingRol" class="aqui pt-0" id="institucion" placeholder="Seleccionar el rol" :key="rolId" v-model="rol" :disabled="!roles[0]">
                        <template #message-danger v-if="errorFields.includes('rol')">
                            Requerido
                        </template>
                        <template>
                            <vs-option v-for="option in roles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getInfoRoles()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <crear-rol v-model="activeCrear" :instituciones="instituciones" :institucionId="institucionId" @refreshTable="getInfo"></crear-rol>
        <gestion-roles class="mt-5" :permisos="permisos" @refreshTable="getInfoRoles"></gestion-roles>
    </div>
</template>
<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
import CrearRol from './modal/crear.vue'
import GestionRoles from './tabla-gestion-roles.vue'
export default {
    props: [
        'personaRol'
    ],
    data:() =>({
        activeCrear: false,
        institucion:'',
        instituciones: [],
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        rol: '',
        roles: [],
        rolId: (new Date()).getTime(),
        loadingRol: false,
        errorFields: [],
        permisos: []
    }),
    components:{
       CrearRol,
       GestionRoles
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await accesibilidad.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },  
        async getRol(){
            try {
                this.loadingRol = true
                const response = await accesibilidad.getRol(this.institucion)
                this.roles = response.data
                this.rolId = (new Date()).getTime()
                this.loadingRol = false
            }
            catch{

            }
        },
        getInfo(institucion, rol){
            this.institucion = institucion
            this.rol = rol
            this.getInfoRoles()
        },
        async getInfoRoles(){
            const loading = this.$vs.loading()
            try{
                const params = {
                    page: 1,
                    institucion_id: this.institucion,
                    role_id: this.rol,
                }
                const response = await accesibilidad.getInfoRoles(params)
                loading.close()
                const infoData = this.getEliminarNameKey(response.data)
                this.getArray(infoData)
            }
            catch(error){
                console.log(error)
                loading.close()
                this.$vs.notification({
                    progress: 'auto',
                    color: 'success',
                    position: null,
                    title: 'Se produjo un error',
                    text: 'Favor de contactar al adminsitrador'
                })
            }
        },
        getEliminarNameKey(info){
            const datos = Object.values(info)
            return datos
        },
        getArray(info){
            let fathers = []
            info.forEach(element => {
                if(JSON.parse(this.personaRol).tipoUserPrincipal == "Personal central - TI"){
                    fathers.push(element.father)
                }else if(element.father != 'Estadisticas Home'){
                    fathers.push(element.father)
                }
            });
            fathers.sort()
            let modulos = []
            for(let i = 0; i < fathers.length; i++ ){
                if(fathers[i + 1] != fathers[i]){
                    modulos.push(fathers[i])
                }
            }
            let permisos = []
            modulos.forEach(i => {
                let obj = {
                    modulo: i
                }
                let perm = info.filter(el => el.father == i)
                var checkPermisos = perm.map(function(e){
                    e.checked = e.checked == 'checked' ? true : false
                    return e
                })
                obj.permisos = checkPermisos
                permisos.push(obj)
            });
            this.permisos = permisos
        }
    },
    watch:{
        institucion(){
            this.getRol()
        }
    }
    
}
</script>